import axios from "@util/axios";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const getSidebarItems = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/side-bar-tab/all`,
      headers: {
         Accept: "*/*"
      }
   });
};
